import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '../../utils/api';
import Header from '../shared/Header';
import Footer from '../shared/Footer';
import SEO from '../shared/SEO';

const PoliciesPage = () => {
  const [policies, setPolicies] = useState([]);

  useEffect(() => {
    api.getPolicies().then(res => setPolicies(res.data)).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen bg-[#FCFBF9]">
      <SEO
        title="Policies"
        description="Read our booking, cancellation, payment, and appointment policies at Crowns by Preshy. Transparent terms for a smooth experience."
        path="/policies"
      />
      <Header />

      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h1 className="font-serif text-4xl lg:text-5xl text-[#3E2723] mb-4 tracking-tight">Our Policies</h1>
            <p className="text-[#786E66] text-lg">Please read our policies before booking</p>
          </div>

          <div className="space-y-8" data-testid="policies-container">
            {policies.length > 0 ? policies.map((policy, idx) => (
              <motion.div
                key={policy.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-[#E6DCD3] p-8"
                data-testid={`policy-${idx}`}
              >
                <h2 className="font-serif text-2xl text-[#3E2723] mb-4">{policy.title}</h2>
                <div className="text-[#1A1A1A] leading-relaxed whitespace-pre-wrap">
                  {policy.content}
                </div>
              </motion.div>
            )) : (
              <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-[#E6DCD3] p-8">
                <p className="text-center text-[#786E66]">No policies available at the moment.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PoliciesPage;
